/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;

  var scanqr = function scanqr() {
    cordova.plugins.barcodeScanner.scan(function (result) {
      $("#rebuy_orderID").val(result.text);
      search();
    }, function (error) {
      alert("Scanning failed: " + error);
    });
  };

  var search = function search() {
    var codeEnter = $("#rebuy_orderID").val();

    if (codeEnter.includes("QR")) {
      window.origin = "rebuy";
      var arr = codeEnter.split(":");
      var data = "\n    {\n      \"orderEntry\":\"" + arr[4] + "\",\n      \"smsnum\":\"" + arr[2] + "-" + arr[3] + "\",\n      \"form\":\"" + arr[1] + "\"\n    }\n    ";
      console.log(data);
      window.data = JSON.parse(data);
      if (window.data.form == "1") $f7.views.main.router.navigate("/kiosk_4d_GD_only/");
      if (window.data.form == "2") $f7.views.main.router.navigate("/kiosk_4d_GD/");
      if (window.data.form == "3") $f7.views.main.router.navigate("/kiosk_6d_GD/");
      if (window.data.form == "4") $f7.views.main.router.navigate("/kiosk_4d_SG_only/");
      if (window.data.form == "5") $f7.views.main.router.navigate("/kiosk_4d_SG/");
      if (window.data.form == "6") $f7.views.main.router.navigate("/kiosk_4d_ST/");
      if (window.data.form == "7") $f7.views.main.router.navigate("/kiosk_6d_ST/");
      if (window.data.form == "8") $f7.views.main.router.navigate("/kiosk_pick_GD/");
      if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
      if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
      if (window.data.form == "11") $f7.views.main.router.navigate("/kiosk_pick_SG_S/");
      $f7.tab.show("#view-home", true);
      return;
    }

    $f7.request({
      method: 'get',
      url: window.waypoint + 'rebuy.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderID: $("#rebuy_orderID").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);
        console.log(data.form);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.origin = "rebuy";
          window.data = data;
          if (window.data.form == "1") $f7.views.main.router.navigate("/kiosk_4d_GD_only/");
          if (window.data.form == "2") $f7.views.main.router.navigate("/kiosk_4d_GD/");
          if (window.data.form == "3") $f7.views.main.router.navigate("/kiosk_6d_GD/");
          if (window.data.form == "4") $f7.views.main.router.navigate("/kiosk_4d_SG_only/");
          if (window.data.form == "5") $f7.views.main.router.navigate("/kiosk_4d_SG/");
          if (window.data.form == "6") $f7.views.main.router.navigate("/kiosk_4d_ST/");
          if (window.data.form == "7") $f7.views.main.router.navigate("/kiosk_6d_ST/");
          if (window.data.form == "8") $f7.views.main.router.navigate("/kiosk_pick_GD/");
          if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
          if (window.data.form == "9") $f7.views.main.router.navigate("/kiosk_pick_SG/");
          if (window.data.form == "10") $f7.views.main.router.navigate("/kiosk_4d_SG_S/");
          if (window.data.form == "11") $f7.views.main.router.navigate("/kiosk_pick_SG_S/");
          $f7.tab.show("#view-home", true);
        } else {
          $f7.dialog.alert("Sorry no order found");
        }
      }
    });
  };

  var keyInEnter = function keyInEnter(id, e, focusOne) {
    $(id).focus();

    if (focusOne != undefined) {
      var intE = setInterval(function () {
        $(id).focus();

        if ($f7.views.main.router.url != focusOne) {
          console.log("remove focus");
          clearInterval(intE);
        }
      }, 1000);
    }

    $(id).on("keydown", function (event) {
      if (event.which == 13) {
        e();
      }
    });
  };

  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
    clearInterval(window.langPlace);
  });
  $on('pageInit', function () {
    if (window.service == "cashier") $(".button-scan").remove();
    keyInEnter("#rebuy_orderID", search, "/kiosk_rebuy/");
    setInterval(function () {
      if ($f7.views.current.name == "rebuy") {
        $("#rebuy_orderID").focus();
      }
    }, 100);
    window.langPlace = setInterval(function () {
      if (window.lang == "tl") document.getElementById("rebuy_orderID").placeholder = "Scan ka hatama ita id hameno";
      if (window.lang == "en") document.getElementById("rebuy_orderID").placeholder = "Scan or Enter your order id";
      if (window.lang == "cn") document.getElementById("rebuy_orderID").placeholder = "扫描或输入您的订单编号";
    }, 1000);
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <!-- <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
        </a> -->
      </div>
      <div class="title">
        <span class='en'>ReBuy</span>
        <span class='cn'>再买</span>
        <span class='tl'>Sosa fila fali</span>
      </div>
    </div>
  </div>
  <div class="page-content">

    <div class="block">
      
        <span class='en'>ReBuy your previous receipt</span>
        <span class='cn'>重新购买您之前的收据</span>
        <span class='tl'>Sosa fila fali ita nia resivu</span>
      
    </div>

    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Order ID/QR</span>
              <span class='cn'>订单编号/QR</span>
              <span class='tl'>Hameno ID/QR</span>
            </div>
            <div class="item-input-wrap">
              <input type="text"  placeholder="Scan or Enter your order id" id="rebuy_orderID"/>
            </div>
          </div>
        </li>
        <li>
          <p class="segmented">

            <button class="button"></button>
            <button class="button button-fill color-theme-orange button-scan" @click="${scanqr}">
              <span class='en'>Scan</span>
              <span class='cn'>扫描</span>
              <span class='tl'>Scan</span>
            </button>
            <button class="button button-fill" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>BUKA</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>


 

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '5d468383e3';
export default framework7Component;